import React from "react";
import { HorizRule } from "../core/pdf/types";
import { useContentState } from "./useContentState";
// import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";

export function HREditor(props: {
	hr: HorizRule,
}) {
	// const designer = useDesigner();

	const elementContext = useElementContext(props.hr);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				style={{
					lineHeight: 1,
					position: "relative",
				}}
				className={"hr content-element " + state.classes}
				data-key={props.hr.id}
				id={state.elementID}
				tabIndex={0}
			>
				&nbsp;
				<div style={{
					borderTop: "solid black 1px",
					position: "absolute",
					top: "50%",
					left: 0,
					right: 0,
				}} />
			</div>
		</ElementContext.Provider>
	);
}
